import React from "react";
import { Link } from "react-router-dom";
import { PRE_EP_HOME } from "../../config/preEpStage";

/**
 * Card on the regular home page of a Pre-EP company, for CertainPath staff
 * working in it (the company's own users only ever see the Pre-EP pages).
 */
const PreEpStepsCard: React.FC = () => (
  <div className="relative mx-auto max-w-5xl px-4 pt-6 sm:px-6 lg:max-w-6xl lg:px-8 xl:max-w-7xl">
    <div className="flex flex-col items-start gap-3 rounded-xl bg-[#0A1430] px-5 py-4 text-white sm:flex-row sm:items-center sm:gap-4">
      <span className="inline-flex min-h-[26px] items-center gap-2 rounded-full border border-[#2C3A66] bg-[#111D40] px-[11px] text-[13px] font-bold text-[#E6EAF5]">
        <span
          aria-hidden="true"
          className="h-[7px] w-[7px] rounded-full bg-[#E0103F]"
        />
        Pre-EP stage
      </span>
      <p className="m-0 min-w-0 flex-1 text-[15px] text-[#D3D9EA]">
        This company&rsquo;s members see only their Pre-EP getting-started steps
        until they finish EP.
      </p>
      <Link
        className="inline-flex h-10 flex-none items-center rounded-full bg-[#E0103F] px-5 text-[15px] font-bold text-white no-underline transition-colors hover:bg-[#C40E37] hover:text-white hover:no-underline"
        to={PRE_EP_HOME}
      >
        View their steps
      </Link>
    </div>
  </div>
);

export default PreEpStepsCard;
